import React from 'react';
import i18n from 'i18next';
import VippedPage from '../../components/Views/VippedPage';
import { getSeoData } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';

const Vipped = () => <VippedPage />;

Vipped.getInitialProps = async ({ apolloClient, asPath, req }) => {
  const seoData = await getSeoData(apolloClient, asPath, req);

  return {
    seoData
  };
};

Vipped.getLayout = page => (
  <Layout
    isShowBackButton
    isBottomNavigation
    headerTitle={i18n.t('sections.vipped.title')}
  >
    {page}
  </Layout>
);

export default Vipped;
